import styled from 'styled-components';

const AdminActionsWrapper = styled.div`
  height: 100dvh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .organizer-actions-container {
    margin-top: 20px;
    max-width: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .create-organizer-modal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .create-organizer-btn,
  .add-court-btn,
  .delete-court-btn,
  .delete-organizer-btn {
    margin: 20px 0;
  }
`;

export default AdminActionsWrapper;
